import React from "react";
import { IconClock, IconList, IconPlayerPlay } from "@tabler/icons-react";

const QuizLandingPage = ({ quizData, onStart }) => {
  const { title, description, timeLimit, questionCount } = quizData || {
    title: "Assessment",
    description: "Loading quiz details...",
    timeLimit: 0,
    questionCount: 0,
  };

  return (
    <div
      className="d-flex flex-column justify-content-center align-items-center p-4"
      style={{ minHeight: "600px", width: "100%", backgroundColor: "#fcfdfe" }}
    >
      <div
        className="card shadow-sm border-0 rounded-3 overflow-hidden"
        style={{ maxWidth: "600px", width: "100%" }}
      >
        <div className="card-body p-5 bg-white text-center">
          <div className="mb-4">
               <div className="avatar avatar-xl bg-blue-lt text-blue rounded-circle mb-3 mx-auto">
                    <IconList size={40} />
               </div>
               <h3 className="fw-bold text-dark">{title}</h3>
          </div>

          <p className="text-muted mb-4 px-md-4" style={{ lineHeight: "1.7", fontSize: '1rem' }}>
            {description}
          </p>

          <div className="row g-3 mb-5 mt-4">
            <div className="col-6">
              <div className="p-3 border rounded-3 bg-light-subtle d-flex flex-column align-items-center">
                <IconClock className="text-primary mb-2" size={24} />
                <div className="text-muted small text-uppercase fw-bold mb-1" style={{ fontSize: "0.7rem" }}>
                  Time Limit
                </div>
                <div className="h4 mb-0 fw-bold">{timeLimit} Mins</div>
              </div>
            </div>
            <div className="col-6">
              <div className="p-3 border rounded-3 bg-light-subtle d-flex flex-column align-items-center">
                <IconList className="text-primary mb-2" size={24} />
                <div className="text-muted small text-uppercase fw-bold mb-1" style={{ fontSize: "0.7rem" }}>
                  Questions
                </div>
                <div className="h4 mb-0 fw-bold">{questionCount} Items</div>
              </div>
            </div>
          </div>

          <div className="alert alert-info border-0 rounded-3 d-flex align-items-center justify-content-center gap-2 py-3 mb-5">
            <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-info-circle" width="20" height="20" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                <circle cx="12" cy="12" r="9"></circle>
                <line x1="12" y1="8" x2="12.01" y2="8"></line>
                <polyline points="11 12 12 12 12 16 13 16"></polyline>
            </svg>
            <span className="small fw-medium">The timer begins as soon as you click start.</span>
          </div>

          <button
            onClick={onStart}
            className="btn btn-primary d-inline-flex align-items-center justify-content-center gap-2 px-5 py-3 fw-bold rounded-pill shadow-sm transition-all hover-translate-y"
            style={{ fontSize: '1.1rem', letterSpacing: '0.5px' }}
          >
            <IconPlayerPlay size={20} fill="currentColor" />
            START ASSESSMENT
          </button>
        </div>
      </div>
    </div>
  );
};

export default QuizLandingPage;
